// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dp-custom-input{height:1.75rem}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,iBAAA,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
